import React from "react";
import { FaYoutube } from "react-icons/fa6";
import {Link } from 'react-router-dom';

function ConclaveEventCard({ date, name, details, time, district, youtubeLink , handleViewGallery }) {

    const calculateDaysLeft = () => {
        const currentDate = new Date(); // Current date
        const targetDate = new Date(date); // Event date

        // Calculate the difference in time (milliseconds)
        const timeDifference = targetDate - currentDate;

        // Convert time difference from milliseconds to days
        const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

        // Return 0 if the event date has already passed
        return daysLeft > 0 ? daysLeft : 0;
    };


    return (
        <div className="relative animate-slide-in" >
            <div className=" w-full h-[21px] left-0 top-0 relative bg-[#0041e8] rounded-[10px]"></div>
            <div className=" w-full h-fit left-0 top-[-15px] relative bg-[#f0f0f0] rounded-[10px] px-3 py-2">
                <div className=" flex justify-between text-sm">
                    <span>{date}</span>
                    <h1 className="  ">{district}</h1>
                </div>
                <div className="my-3">
                    <h1 className="text-xl font-bold">{name}</h1>
                    <span className=" text-sm font-semibold opacity-40"> {details}</span>
                </div>
                <div className="my-4">
                    <div className="h-[1px] bg-gray-500" />
                </div>
                <div className="flex justify-between my-2">
                </div>
                <div className="flex justify-between items-center">
                    <h1 className="text-blue-700 hover:cursor-pointer">
                        Time: <span>{time}</span>
                    </h1>
                    <div className=" flex items-center gap-4">
                        <button
                            onClick={handleViewGallery}
                            to="/pre-conclave"
                            className=" text-[#0041e8]  text-xs font-medium rounded"
                        >
                            View Gallery
                        </button>
                        {youtubeLink &&<Link
                            to={youtubeLink.replace('https://www.youtube.com/embed/', 'https://www.youtube.com/watch?v=')}
                            target="_blank"
                            referrerPolicy="no-referrer"
                            className=" flex items-center gap-2  text-red-600 bg-opacity-60 text-xs font-medium rounded"
                        >
                            <FaYoutube size={24} />
                            <span className=" hidden sm:block">Watch Video</span>
                            
                        </Link>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConclaveEventCard;
